import React from 'react'
import about_stats from "../Data/about_stats"



const StatsBlock = () => {
  return (
    <>
        <div className="stats-container">
            <div className="container stats-box">
                {about_stats.map((i) => {
                    return (
                        <div key={i.id} id={i.id} className="stats-card">
                            <div className="stats-icon-container">
                                <span className="stats-icon">
                                    {i.icon}
                                </span>
                            </div>
                            <div className="stats-info-container">
                                <h1 className="stats-title">{i.title}</h1>
                                <p className="stats-subtitle">{i.subtitle}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    </>
  )
}

export default StatsBlock

